import Client from "./modules/Client";

export default class Tracker {

    static identify(user_id) {
    }

    static track(eventName, properties) {

        let defaultProperties = {
            $screen_width: screen.width,
            $screen_height: screen.height,
        };

        Client.post('/api/v1.1/tracking/event', {
            event: eventName,
            properties: {...defaultProperties, ...properties ?? {}},
        });
    }
}